const state = {
	currentPart: 0, //当前展示模块
	isShowPop: false, //是否展示右侧气泡
	isShowAllPart: false, //是否展开顶部全部选项
	hasApplyNum: 0, //已经申请的数量（气泡中用）
	sliderLists: window.____global.cateList, //顶部全部滑动模块
	mcity: '', //cookie中获取的city信息
	source: '', //入口url中获取的来源,(请求数据时要用)
	userid: '', //cookie的ppu中的UID,(获取用户投递简历数时用)
	dispcateid: '', //从url中获取并在请求数据时带上此参数
	currentScrollTop: 0 //仅用于顶部全部模块的点击展开后立即点击收起时记录当前页面位置(页面的滚动监听事件不能用此字段)
};
export default state;



// WEBPACK FOOTER //
// ./src/store/state.js